
import React from "react";

export const HeroBackground = () => {
  return (
    <>
      {/* Gradient background with texture */}
      <div className="absolute inset-0 bg-gradient-to-b from-blue-50 to-indigo-50/50 -z-10" />
      
      {/* Mesh gradient effects */}
      <div className="absolute top-20 right-[10%] w-[500px] h-[500px] bg-[#0072ff]/5 rounded-full blur-3xl -z-10" />
      <div className="absolute bottom-10 left-[5%] w-[600px] h-[600px] bg-[#1211ca]/5 rounded-full blur-3xl -z-10" />
      
      {/* Grid pattern overlay (subtle) */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGZpbGw9IiNmZmZmZmYiIGQ9Ik0wIDBoNjB2NjBIMHoiLz48cGF0aCBkPSJNNjAgMzBjMCAxNi41NjktMTMuNDMxIDMwLTMwIDMwQzEzLjQzMSA2MCAwIDQ2LjU2OSAwIDMwIDAgMTMuNDMxIDEzLjQzMSAwIDMwIDBjMTYuNTY5IDAgMzAgMTMuNDMxIDMwIDMweiIgc3Ryb2tlPSIjRTBFMEUwIiBzdHJva2Utd2lkdGg9Ii41Ii8+PC9nPjwvc3ZnPg==')] opacity-[0.03] -z-10" />
    </>
  );
};
